"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
/**
 * @internal
 */
var Tabs = /** @class */ (function (_super) {
    tslib_1.__extends(Tabs, _super);
    function Tabs(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedTabId: props.selectedTabId || ((_b = (_a = props.tabs) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id),
        };
        return _this;
    }
    Tabs.prototype.selectTab = function (tab) {
        var selectedTabId = tab === null || tab === void 0 ? void 0 : tab.id;
        var noChange = selectedTabId === this.state.selectedTabId;
        if (noChange) {
            return;
        }
        this.setState({
            selectedTabId: selectedTabId,
        });
        this.props.onTabSelect(tab);
    };
    Tabs.prototype.renderTab = function (tab) {
        var _a;
        var _this = this;
        var tabClassName = classnames_1.default((_a = {
                "is-active": tab.id === this.state.selectedTabId,
                "gd-tab": true
            },
            _a["s-" + util_1.stringUtils.simplifyText(tab.id)] = true,
            _a));
        return (react_1.default.createElement("div", { className: tabClassName, key: tab.id, onClick: function () {
                _this.selectTab(tab);
            } },
            react_1.default.createElement("span", null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: tab.id }))));
    };
    Tabs.prototype.renderTabs = function () {
        return this.props.tabs.map(this.renderTab, this);
    };
    Tabs.prototype.render = function () {
        var classNames = classnames_1.default(this.props.className, {
            "gd-tabs": true,
            small: true,
        });
        return react_1.default.createElement("div", { className: classNames }, this.renderTabs());
    };
    Tabs.defaultProps = {
        className: "",
        onTabSelect: noop_1.default,
        selectedTabId: "",
        tabs: [],
    };
    return Tabs;
}(react_1.Component));
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map